import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { ThemePrimary, ThemeText } from '../../context/theme/ThemeConstantsUpdated';

const { mainText, secondaryText } = ThemeText;
const { primaryTextHover } = ThemePrimary;

export const FooterColumn = (props: Props) => {
  const { column, className, isVibrant } = props;

  return (
    <div className={className}>
      <h3 className={classNames(isVibrant ? 'text-white' : mainText, 'text-sm font-semibold leading-6')}>
        {column.label}
      </h3>
      <ul role="list" className="mt-6 space-y-4">
        {column.items.map((item) => (
          <li key={item.label}>
            <Link
              to={item.link}
              className={classNames(
                isVibrant ? 'text-gray-100' : secondaryText,
                primaryTextHover,
                { 'pointer-events-none': item.disabled },
                'text-sm leading-6'
              )}
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

type Props = {
  column: FooterColumn;
  className?: string;
  isVibrant?: boolean;
};

export type FooterColumn = {
  label: string;
  items: Array<FooterItem>;
};

type FooterItem = { label: string; link: string; disabled?: boolean };
